<div class="card voucher-manager">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center flex-wrap page-header mb-3">
      <h5 class="mb-0">
        <i class="ri-coupon-3-line mr-1"></i>{{ "KHO VOUCHER" | translate }}
      </h5>
      <div class="d-flex flex-wrap header-actions">
        <button
          class="btn btn-success"
          (click)="openCreateVoucherBatchModal(contentCreate)"
        >
          <i class="ri-add-circle-line"></i> Tạo lô voucher
        </button>
        <button class="btn btn-outline-primary ml-2" (click)="exportVoucher()">
          <i class="ri-file-excel-2-line"></i> Xuất danh sách mã voucher
        </button>
      </div>
    </div>

    <div class="filter-panel p-3 mb-3">
      <div class="row align-items-end">
        <div class="form-group col-lg-3 col-md-6">
          <label>{{ "Mã voucher" | translate }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="filter.code"
            placeholder="Nhập mã voucher"
          />
        </div>
        <div class="form-group col-lg-3 col-md-6">
          <label>{{ "Trạng thái" | translate }}</label>
          <select class="form-control" [(ngModel)]="filter.active">
            <option value="">Tất cả</option>
            <option value="1">Hoạt động</option>
            <option value="0">Ngừng hoạt động</option>
          </select>
        </div>
        <div class="form-group col-lg-3 col-md-6">
          <label>{{ "Trạng thái sử dụng" | translate }}</label>
          <select class="form-control" [(ngModel)]="filter.isUsed">
            <option value="">Tất cả</option>
            <option value="1">Đã sử dụng</option>
            <option value="0">Chưa sử dụng</option>
          </select>
        </div>
        <div class="form-group col-lg-3 col-md-6">
          <label>{{ "Loại tặng loa" | translate }}</label>
          <select class="form-control" [(ngModel)]="filter.giveawayType">
            <option value="">Tất cả</option>
            <option
              *ngFor="let item of giveawayTypeOptions"
              [value]="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </div>
        <div class="form-group col-lg-3 col-md-6">
          <label>{{ "Từ ngày" | translate }}</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="filter.startDate"
          />
        </div>
        <div class="form-group col-lg-3 col-md-6">
          <label>{{ "Đến ngày" | translate }}</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="filter.endDate"
          />
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12">
          <button class="btn btn-primary" (click)="submitFilter()">
            <i class="ri-search-line"></i>
            {{ "PAGE.REPORT.Search" | translate }}
          </button>

          <button
            class="btn btn-dark ml-2"
            *ngIf="searching"
            (click)="clearFilter()"
          >
            <i class="ri-eraser-line"></i> {{ "FORM.Clear" | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-bordered table-hover align-middle text-center voucher-table">
        <thead class="bg-light">
          <tr>
            <th>#</th>
            <th>{{ "Mã Voucher" | translate }}</th>
            <th>{{ "Mô tả" | translate }}</th>
            <th>{{ "Loại tặng loa" | translate }}</th>
            <th>{{ "Giá trị" | translate }}</th>
            <th>{{ "Hiệu lực" | translate }}</th>
            <th>{{ "Lượt dùng" | translate }}</th>
            <th>{{ "Trạng thái HĐ" | translate }}</th>
            <th>{{ "Trạng thái SD" | translate }}</th>
            <th>{{ "Ngày tạo" | translate }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td>{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
            <td class="text-start">
              <div class="voucher-code">{{ data?.code || "-" }}</div>
            </td>
            <td class="text-start description-cell">
              {{ data?.description || "Không có" }}
            </td>
            <td>
              <span
                class="badge badge-pill px-3 py-2"
                [ngClass]="{
                  'badge-purple': data?.giveaway_type === 'permanent_giveaway',
                  'badge-info text-white': data?.giveaway_type === 'normal_giveaway',
                  'badge-light text-muted': !data?.giveaway_type
                }"
              >
                {{
                  data?.giveaway_type === "normal_giveaway"
                    ? "Tặng loa bình thường"
                    : data?.giveaway_type === "permanent_giveaway"
                    ? "Tặng loa hẳn"
                    : "Giảm giá thường"
                }}
              </span>
            </td>
            <td>
              <span *ngIf="data?.type === 'percent'">{{ data?.amount }}%</span>
              <span *ngIf="data?.type !== 'percent'"
                >{{ data?.amount | number }} đ</span
              >
            </td>
            <td class="validity-cell">
              <ng-container *ngIf="data?.start_at || data?.end_at; else noLimit">
                <div>{{ data?.start_at ? (data.start_at | date : "dd/MM/yyyy") : "..." }}</div>
                <div class="text-muted">đến</div>
                <div>{{ data?.end_at ? (data.end_at | date : "dd/MM/yyyy") : "..." }}</div>
              </ng-container>
              <ng-template #noLimit>
                <span class="text-muted">Không giới hạn</span>
              </ng-template>
            </td>
            <td>{{ data?.used_count || 0 }}/{{ data?.usage_limit != null ? data.usage_limit : "∞" }}</td>
            <td>
              <span
                class="badge px-3 py-2"
                [ngClass]="data?.active ? 'badge-success' : 'badge-secondary'"
              >
                {{ data?.active ? "Hoạt động" : "Ngừng hoạt động" }}
              </span>
            </td>
            <td>
              <span
                class="badge px-3 py-2"
                [ngClass]="{
                  'badge-secondary': data?.used_count === 0,
                  'badge-warning text-dark':
                    data?.used_count > 0 &&
                    data?.used_count < data?.usage_limit,
                  'badge-danger': data?.used_count >= data?.usage_limit
                }"
              >
                {{
                  data?.used_count === 0
                    ? "Chưa sử dụng"
                    : data?.used_count < data?.usage_limit
                    ? "Đã sử dụng"
                    : "Hết mã"
                }}
              </span>
            </td>
            <td>{{ data?.created_at | date : "dd/MM/yyyy HH:mm" }}</td>
          </tr>
          <tr *ngIf="!listData?.length">
            <td colspan="10" class="text-muted py-4">Không có dữ liệu</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <div
        class="col-sm-12 col-md-7 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật thông tin KH</h5>

    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form [formGroup]="formData" (ngSubmit)="onUpdateCustomer()">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Tên tài khoản</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="accountName"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('accountName')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Mật khẩu</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="accountPassword"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('accountPassword')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Mã số thuế</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="taxCode"
                [ngClass]="{
                  'is-invalid': submitted && formData.get('taxCode')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Loại hóa đơn</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="invoice_type"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('invoice_type')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">Mẫu số</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="template_code"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('template_code')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Ký hiệu</label
            >
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="invoice_series"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('invoice_series')?.invalid
                }"
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label"
              >Loại hình kinh doanh</label
            >
            <div class="col-md-10">
              <select
                class="form-select form-control"
                formControlName="business_type"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.get('business_type')?.invalid
                }"
              >
                <option value="enterprise">Doanh nghiệp</option>
                <option value="household">Hộ kinh doanh</option>
              </select>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            Đóng
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            Lưu
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentLink role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Liên kết thiết bị với đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceLink(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Đơn hàng" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="data"
                [ngClass]="{ 'is-invalid': submitted && form.data.errors }"
                disabled
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số thiết bị cần gán" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="quantity"
                [ngClass]="{ 'is-invalid': submitted && form.quantity.errors }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Thiết bị" | translate
            }}</label>
            <div class="col-md-10">
              <ng-select
                [items]="listDevices"
                bindLabel="serial_number"
                bindValue="serial_number"
                formControlName="serial_number"
                [maxSelectedItems]="formData.get('quantity').value"
                [multiple]="true"
                placeholder="{{ 'Chọn thiết bị' | translate }}"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentCreate role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Tạo lô mã giảm giá</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-3">
    <div class="text-left">
      <form
        (ngSubmit)="createVoucherBatch(formData.value)"
        [formGroup]="formData"
      >
        <div class="row">
          <!-- Quantity -->
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label required_label"
              >Số lượng</label
            >
            <div class="col-md-9">
              <input
                type="number"
                class="form-control"
                formControlName="quantity"
                placeholder="Nhập số lượng mã (1 - 1000)"
                [ngClass]="{
                  'is-invalid': submitted && form.quantity.errors
                }"
              />
              <div
                *ngIf="submitted && form.quantity.errors"
                class="invalid-feedback"
              >
                Vui lòng nhập số lượng hợp lệ (1 - 1000)
              </div>
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md col-form-label required_label"
              >OTP xác thực</label
            >

            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                formControlName="otpValue"
                placeholder="Nhập OTP"
                maxlength="8"
              />
            </div>

            <div class="col-md">
              <button
                type="button"
                class="btn btn-primary w-100"
                (click)="sendOtp()"
                [disabled]="isSendingOtp"
              >
                {{ isSendingOtp ? "Đang gửi..." : "Gửi OTP" }}
              </button>
            </div>

            <div
              class="col-md-12"
              *ngIf="otpError"
              style="color: red; font-size: 13px"
            >
              {{ otpError }}
            </div>
          </div>
          <!-- Prefix -->
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label">Tiền tố (Prefix)</label>
            <div class="col-md-9">
              <input
                type="text"
                class="form-control"
                formControlName="prefix"
                placeholder="VD: TMT"
                maxlength="3"
              />
            </div>
          </div>

          <!-- Giveaway type -->
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label">Loại tặng loa</label>
            <div class="col-md-9">
              <select class="form-control" formControlName="giveawayType">
                <option value="">Giảm giá thường (không tặng loa)</option>
                <option
                  *ngFor="let item of giveawayTypeOptions"
                  [value]="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>

          <!-- Effective date range -->
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label">Ngày bắt đầu hiệu lực</label>
            <div class="col-md-9">
              <input
                type="date"
                class="form-control"
                formControlName="startAt"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label">Ngày hết hiệu lực</label>
            <div class="col-md-9">
              <input
                type="date"
                class="form-control"
                formControlName="endAt"
              />
            </div>
          </div>

          <!-- Agencies -->
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label"
              >Chi nhánh áp dụng</label
            >
            <div class="col-md-9">
              <ng-select
                [items]="listAgencies"
                bindLabel="agency_name"
                bindValue="id"
                formControlName="agencyIds"
                [multiple]="true"
                placeholder="Để trống = áp dụng mọi chi nhánh"
              >
              </ng-select>
            </div>
          </div>

          <!-- Description -->
          <div class="form-group row col-md-12">
            <label class="col-md-3 col-form-label">Mô tả</label>
            <div class="col-md-9">
              <textarea
                rows="2"
                class="form-control"
                formControlName="description"
                placeholder="Nhập mô tả (nếu có)"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="text-center mt-3">
          <button
            type="submit"
            class="btn btn-success btn-lg mr-3"
            style="width: 150px"
            [disabled]="
              !formData.get('quantity')?.value ||
              !formData.get('otpValue')?.value
            "
          >
            Tạo mới
          </button>

          <button
            type="button"
            class="btn btn-secondary btn-lg"
            style="width: 150px"
            (click)="modal('close click')"
          >
            Đóng
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #orderDetailModal role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Chi tiết đơn hàng</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div
    class="modal-body p-3"
    *ngIf="selectedOrder?.metadata?.accViettelInvoice"
  >
    <table class="table table-bordered table-sm">
      <tr>
        <th>Tên tài khoản</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.account_name }}</td>
      </tr>
      <tr>
        <th>Loại hình kinh doanh</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.business_type }}</td>
      </tr>
      <tr>
        <th>Ký hiệu hoá đơn</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.invoice_series }}</td>
      </tr>
      <tr>
        <th>Loại hoá đơn</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.invoice_type }}</td>
      </tr>
      <tr>
        <th>Mã số thuế</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.tax_code }}</td>
      </tr>
      <tr>
        <th>Mẫu hoá đơn</th>
        <td>{{ selectedOrder.metadata.accViettelInvoice.template_code }}</td>
      </tr>
    </table>
  </div>
</ng-template>
